jQuery(document).ready(function ($) {
	
	$(document).on('click', '.ajax_add_to_cart_custom', function (e) {
		e.preventDefault();

		var qty = $(this).closest('.product-item').find('.unit-qty-input').val();

		var $this = $(this),
			gridItem = $this.closest('.nt-grid-item'),
			aniItem = $('.cart-animation'),
			variant_id = $this.data('pid');
		$this.addClass('btn-loading');
		$this.parent().addClass('fix_nt_tt');
      let currentele = $(this);
      let prevText = currentele.text();
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: { quantity: qty, id: variant_id },
			dataType: 'json',
			success: function (cart) {
              currentele.addClass('atc_success');
               currentele.html('<i class="fa fa-check" aria-hidden="true"></i> Added');
				$.get('/cart?view=json', function (data) {
					/*optional stuff to do after success */
					$('.widget_shopping_cart_content').html(data);
				}).always(function () {
					var subtotal = parseFloat($('.widget_shopping_cart_body').data('subtotal'));
					$(".nathan-cart-subtotal >span").html(elessiShopifyPre.formatMoney(subtotal, nathan_settings.moneyFormat));
					var quantity = parseInt(gridItem.find('[name="quantity"]').val(), 10) || 1;
					//elessiShopify.cartAnimation($this,quantity,aniItem);
					elessiShopify.favicon_counter(parseInt($('.widget_shopping_cart_body').data('count')));
					$(".cartCount").html($('.widget_shopping_cart_body').data('count'));
					//elessiShopify.nanoScroller();
					if (nathan_settings.show_multiple_currencies && elessiShopifyPre.StorageCurrency() !== null) {
						Currency.convertAll(shopCurrency, elessiShopifyPre.StorageCurrency(), '.widget_shopping_cart_content span.money');
						Currency.convertAll(shopCurrency, elessiShopifyPre.StorageCurrency(), '.nathan-cart-subtotal span.money');
					}
					if (parseInt($('.widget_shopping_cart_body').data('count')) > 0) { elessiShopify.initAddToCart(cart.image, cart.title); }
					if (window.Shopify && Shopify.StorefrontExpressButtons && nathan_settings.use_additional_checkout_buttons) {
						Shopify.StorefrontExpressButtons.initialize();
					}
					$this.removeAttr("disabled").css('pointer-events', 'auto').removeClass("btn-loading");
				});
              setTimeout(function(){
                currentele.removeClass('atc_success');
                currentele.text(prevText);
              }, 5000)
			},
			error: function (XMLHttpRequest, textStatus) {
				$this.removeClass("btn-loading");
				elessiShopify.onError(XMLHttpRequest, textStatus);
			}
		}).done(function () {
		});
	})

   // Search add to cart JS
  console.log("WORKING");
   $(document).on('click', '.add_to_cart_search', function (e) {
    e.preventDefault();
      // Clear any error msgs if any
     $('.search-error-msg').css("display", "none");
      // GRAB VALUES
      var qty = $(this).closest('.search-add-to-cart-form').find('.qty').val();
      var product_handle = $(this).closest('.search-add-to-cart-form').find('.product_handle').val()
      var addToCartBtnRef = $(this).closest('.search-add-to-cart-form').find('.add_to_cart_search');
    
  //       console.log("producthandle", product_handle);
		// console.log("Quantity", qty);

        // Grab variantID with productID
        $.ajax({
			type: 'GET',
			url: `/products/${product_handle}.js`,
			dataType: 'json',
			success: function (response) {
              console.log("PRODUCT FROM FETCH", response);

              // Add to cart with variantID 
              var variant_id = response.variants[0].id;
              // console.log("variant_ID", variant_id);
              var productID = response.id;

              $.ajax({
    			type: 'POST',
    			url: '/cart/add.js',
    			data: { quantity: qty, id: variant_id },
    			dataType: 'json',
    			success: function (cart) {
                  console.log("SUCCESS", cart);
                   addToCartBtnRef.addClass('atc_success facheck');
               addToCartBtnRef.prop('value', '✓ Added');
                  $.get('/cart?view=json', function (data) {
					/*optional stuff to do after success */
					$('.widget_shopping_cart_content').html(data);
    				}).always(function () {
  					var subtotal = parseFloat($('.widget_shopping_cart_body').data('subtotal'));
  					$(".nathan-cart-subtotal >span").html(elessiShopifyPre.formatMoney(subtotal, nathan_settings.moneyFormat));
  					var quantity = qty;
                    
  					//elessiShopify.cartAnimation($this,quantity,aniItem);
  					elessiShopify.favicon_counter(parseInt($('.widget_shopping_cart_body').data('count')));
  					$(".cartCount").html($('.widget_shopping_cart_body').data('count'));
  					//elessiShopify.nanoScroller();
  					if (nathan_settings.show_multiple_currencies && elessiShopifyPre.StorageCurrency() !== null) {
  						Currency.convertAll(shopCurrency, elessiShopifyPre.StorageCurrency(), '.widget_shopping_cart_content span.money');
  						Currency.convertAll(shopCurrency, elessiShopifyPre.StorageCurrency(), '.nathan-cart-subtotal span.money');
  					}
  					if (parseInt($('.widget_shopping_cart_body').data('count')) > 0) { elessiShopify.initAddToCart(cart.image, cart.title); }
  					if (window.Shopify && Shopify.StorefrontExpressButtons && nathan_settings.use_additional_checkout_buttons) {
  						Shopify.StorefrontExpressButtons.initialize();
  					}
    				});

                  
                    
                    // Change add to cart button text
                 //   addToCartBtnRef.prop('value', 'Added! ✅');
                    // after specified time, reset to default
                    setTimeout(() => {
                      
                     
                addToCartBtnRef.removeClass('atc_success');
               addToCartBtnRef.prop('value', 'ADD TO CART');

                    }, 5000);
                  
                },
                error: function (err) {
                  console.log("There was an error!!");
                  // Display error popup 
                  $(`#error-${productID}`).css("display", "block");
                }
            
            })
              

            },
          error: function (err) {
            console.log("There was an error!");
          }
        });
      // Make AJAX REQUEST
      // alert("CLICKED!");
  });

  
});